import React, { Component } from 'react';

import Header from '../components/Header';
import OldHeader from '../components/OldHeader';
import Footer from '../components/Footer';
import MapperControl from '../components/MapperControl';
import Legend from '../components/Legend';
import DPCSection from '../components/DPCSection';
import AboutMapperSection from '../components/AboutMapperSection';
import AddYourself from '../components/AddYourself';
// import '../style/StatesPage.scss';

class StatesPage extends Component {
  render() {
    return (
      <div>
        <div className="wide">
          {false ? <Header /> : <OldHeader />}

          <div className="StatesPage">
            <div className="row HeaderRow">
              <div className="col">
                <h1>DPC By State</h1>
              </div>
            </div>
            <MapperControl
              setNumPracs={numPracs => {
                this.setState({ numPracs: numPracs });
              }}
            />

            <DPCSection />
            <AboutMapperSection numPracs={this.state.numPracs} />
            <AddYourself />
          </div>

          <br />
          <br />
          <br />
          <Footer />
        </div>
      </div>
    );
  }
}

export default StatesPage;
